import React, { Suspense, useEffect, useState } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";
import useSEO from "@/hooks/useSEO";
// lazy element
const MainPageItems = React.lazy(() => import("@/components/MainPageItems"));


const unqKey:string = nanoid(12);

const Render = ( props:any ) => {
    useSEO(props.locals);
    return (<Suspense><MainPageItems /></Suspense>)
}

const Home = () => {
    console.log("Home.rendered");
    
    const { siteSettingPayload, webApplicationLanguageISOCode, _viewEvent, _showLoader } = useOutletContext<TOutletContext>();
    const [ contentId ] = useState(metaDataLanguageVersion("mainPageId", siteSettingPayload.languageVersions));

    useEffect(
        () => {
            const element = document.getElementsByClassName("navbar-style-2")?.[0];
            if ( element ) {
                element.classList.remove("navbar-style-2");
                element.classList.add("dark-navbar");
            }
            return () => { _showLoader(); }
        }, []
    )
    useEffect(() => { if ( !isEmpty(contentId) && contentId ) _viewEvent(contentId); }, [contentId])

    return (<Render locals={{language:webApplicationLanguageISOCode, type:"home-page", id:contentId}} />)    
}

export default Home;
